import React, { useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { X } from 'lucide-react';

// ---- Add Lead Modal ----
export function AddLeadModal({ onClose, onSave, users }) {
  const [form, setForm] = useState({ name: '', mobile: '', email: '', city: '', alternateWhatsApp: '', personalLoan: '', creditCard: '', employmentStatus: '', harassment: '', description: '' });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const save = async () => {
    if (!form.name || !form.mobile) return toast.error('Name and mobile required');
    setSaving(true);
    try {
      await api.post('/leads', form);
      onSave();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Failed to add lead');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">Add New Lead</div>
          <button className="btn-icon" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="modal-body">
          <div className="grid grid-2">
            <div className="form-group">
              <label className="form-label">Full Name *</label>
              <input className="form-control" value={form.name} onChange={e => set('name', e.target.value)} placeholder="Amit Kumar" />
            </div>
            <div className="form-group">
              <label className="form-label">Mobile *</label>
              <input className="form-control" value={form.mobile} onChange={e => set('mobile', e.target.value)} placeholder="9XXXXXXXXX" maxLength={10} />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-control" type="email" value={form.email} onChange={e => set('email', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">City</label>
              <input className="form-control" value={form.city} onChange={e => set('city', e.target.value)} placeholder="Noida" />
            </div>
            <div className="form-group">
              <label className="form-label">Alt. WhatsApp</label>
              <input className="form-control" value={form.alternateWhatsApp} onChange={e => set('alternateWhatsApp', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Employment</label>
              <select className="form-control" value={form.employmentStatus} onChange={e => set('employmentStatus', e.target.value)}>
                <option value="">Select...</option>
                {['Salaried','Self-Employed','Business','Unemployed'].map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Personal Loan (₹)</label>
              <input className="form-control" type="number" value={form.personalLoan} onChange={e => set('personalLoan', e.target.value)} placeholder="500000" />
            </div>
            <div className="form-group">
              <label className="form-label">Credit Card Outstanding (₹)</label>
              <input className="form-control" type="number" value={form.creditCard} onChange={e => set('creditCard', e.target.value)} placeholder="100000" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Harassment Type</label>
            <select className="form-control" value={form.harassment} onChange={e => set('harassment', e.target.value)}>
              <option value="">None</option>
              <option value="not_now">Not Now</option>
              <option value="multiple_calls">Multiple Calls</option>
              <option value="threat_to_visit">Threat to Visit</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea className="form-control" value={form.description} onChange={e => set('description', e.target.value)} placeholder="Brief about client's situation..." />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? <span className="spinner" /> : 'Add Lead'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddLeadModal;
